export const screenshotAssets = {
  androidHome: 'assets/screenshots/android-home-22da64a-zh.png',
  androidGear: 'assets/screenshots/android-gear-library-22da64a-zh.png',
  androidPacking: 'assets/screenshots/android-packing-list-22da64a-zh.png',
  androidTrips: 'assets/screenshots/android-trips-22da64a-zh.png',
  androidSkills: 'assets/screenshots/android-knot-skills-22da64a-zh.png',
  wechatGear: 'assets/screenshots/wechat-gear-management-a1fc941-zh.png',
  wechatKnots: 'assets/screenshots/wechat-knot-skills-a1fc941-zh.png',
  webGear: 'assets/screenshots/web-gear-management-a1fc941-zh.png',
  webGearForm: 'assets/screenshots/web-gear-form-a1fc941-zh.png'
} as const;
